<script lang="ts">
  import { _ } from "svelte-i18n";

  export let msgkey: string = null;
</script>

<div class="alert alert-warning">
  {msgkey ? $_(msgkey) : $_("no_available_data")}
</div>
